import Inputmask from "inputmask";

// IIFE
(($) => {
  toogleLink();
  menu();
  hideSingleItemBreadcrumb();
  currentPage();
  pageSelector();
  servicosLaboratoriais();
  listWithHiddenContent();
  showScrollHeader();
  share();
  slickSlider();
  setContainerToBlock();
  desabilitarEnterPesquisa();
  atrasarHover();
  mudaMatrizCurricular();
  inputmask();
  return;

  function mudaMatrizCurricular() {
    $('select[name="mobile-periods"]').on("change", function () {
      $($(this).val()).collapse();
    })
  }

  function toogleLink() {
    $('#toogle-menu-rapido-mobile').click(function () {
      if ($('.links-rapidos-mobile').find('.link--group-mobile').hasClass('active')) {
        $('.links-rapidos-mobile').find('.link--group-mobile').removeClass('active');
        $(this).find('i').removeClass('fa-chevron-up').addClass('fa-chevron-down');
      } else {
        $('.links-rapidos-mobile').find('.link--group-mobile').addClass('active');
        $(this).find('i').removeClass('fa-chevron-down').addClass('fa-chevron-up');
      }
    })
  }

  function atrasarHover() {
    if(window.innerWidth < 768){
      let hideTimeout;
      $('.has-popup').hover(
        (event) => showItem($(event.target)),
        () => hideTimeout = setTimeout(() => hideAll(), 2000),
      );

      ////

      function showItem(el) {
        hideAll();
        el.find('.popup').find('ul').css({
          "opacity": 1,
          "visibility": "visible",
          "display": "flex"
        });
        enableWaitForClick(el)
      }
      function hideAll() {
        clearTimeout(hideTimeout);
        disableWaitForClick();
        if (window.innerWidth > 768) {
          $('.has-popup > .popup > ul').css({
            "opacity": 0,
            "visibility": "hidden",
            "display": "none"
          });
        } else{
          $('.has-popup > .popup > ul').attr('style', '')
        }
      }
    }

    ////

    let waitForClick;
    function enableWaitForClick(el) {
      disableWaitForClick();
      $(document).on('click', waitForClick = function (event) {
        if ($(event.target).closest(el).length > 0) return;
        hideAll();
      });
    }
    function disableWaitForClick() {
      if (!waitForClick) return;
      $(document).off('click', waitForClick);
    }
  }

  function setContainerToBlock() {
    let selectors = [
      "#block-views-block-infraestrutura-block-1"
    ];

    selectors.forEach((selector) => {
      let aux = $(selector).html();
      $(selector).html("").append("<div class='container'></div>");
      $(selector + " .container").html(aux);
    });
  }

  function desabilitarEnterPesquisa() {
    $('#header-search-field').keydown(function (event) {
      if (event.keyCode == 13) {
        event.preventDefault();
        return false;
      }
    });
  }

  function slickSlider() {
    $('.region.region-destaque-home #block-views-block-home-noticias-com-foto-block-1 .view-content').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 768,
          settings: 'unslick'
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
  }

  function showScrollHeader() {
    window.addEventListener("scroll", (e) => {
      let scrollHeader = $("#scroll-header");
      if (window.scrollY >= 132) {
        scrollHeader.addClass("show");
      } else {
        scrollHeader.removeClass("show");
      }
    })
  }

  function menu() {
    // layout-01: Felipe
    $(".course-card__toggler").on("click", (e) => {
      let courseCard = $(e.target).closest(".course-card");
      if (!courseCard.hasClass("course-card--opened")) {
        courseCard.addClass("course-card--opened");
      } else {
        courseCard.removeClass("course-card--opened");
      }
    })

    $('#menu-principal').on('show.bs.collapse', () => {
      $('body').css('overflow', 'hidden');
    });
    $('#menu-principal').on('hide.bs.collapse', () => {
      $('body').css('overflow', 'auto');
    });
  }
  function hideSingleItemBreadcrumb() {
    const $breadcrumb = $('#breadcrumb');
    const itemsCount = $breadcrumb.find('.breadcrumb').children().length;
    if (itemsCount < 2) {
      $breadcrumb.hide();
    }
  }
  function currentPage() {
    // _page: Rafael
    let hide_current_page_without_scroll_list = [
      '.path-frontpage',
      '.path-admin',
      '.path-user'
    ];

    let hide_current_page_with_scroll_list = [
      '.path-admin',
      '.path-user'
    ];

    let current_page_custom_labels = [
      { selector: '#noticia-interna', label: 'Notícias' },
      { selector: '.page-node-type-agenda', label: 'Agenda' },
      { selector: '.path-frontpage', label: 'Home' }
    ];

    let current_page_elements = document.getElementsByClassName('current-page');

    if (hideElement(hide_current_page_without_scroll_list)) {
      current_page_elements[1].style.display = 'none';
    }

    if (hideElement(hide_current_page_with_scroll_list)) {
      current_page_elements[0].style.display = 'none';
    }

    let custom_label = getCustomLabel(current_page_custom_labels);
    if (custom_label) {
      current_page_elements[0].firstElementChild.firstElementChild.innerHTML = custom_label;
      current_page_elements[1].firstElementChild.firstElementChild.innerHTML = custom_label;
    }

    let page_noticias = document.getElementById('page-noticias');
    if (page_noticias) {
      $('.f20-principal').addClass('container');
    }

    function hideElement(selectors) {
      for (let i = 0; i < selectors.length; i++) {
        if (document.querySelectorAll(selectors[i]).length > 0) {
          return true;
        }
      }
      return false;
    }

    function getCustomLabel(selectors) {
      for (let i = 0; i < selectors.length; i++) {
        if (document.querySelectorAll(selectors[i].selector).length > 0) {
          return selectors[i].label;
        }
      }
      return false;
    }
  }
  function pageSelector() {

    const $pageSelector = $('.page-selector');
    const $scrollHeader = $('#scroll-header');
    const $currentPage = $('.current-page');

    const loggedIn = $('#toolbar-bar').length;
    const top = '30px';
    const topScroll = '50px';
    const topLoggedIn = '69px';

    if (loggedIn) {
      $pageSelector.css('top', topLoggedIn);
    }
    else {
      $pageSelector.css('top', top);
    }

    $pageSelector.on('show.bs.collapse', function () {
      $currentPage.addClass('current-page--open');
    });
    $pageSelector.on('hide.bs.collapse', function () {
      $currentPage.removeClass('current-page--open');
    });
    $(document).on('keydown', function (event) {
      if (!event.key.match(/^Esc/)) return;
      $pageSelector.collapse('hide');
    });

    $(window).on('scroll', function () {
      if ($scrollHeader.hasClass('show')) {
        $pageSelector.css('top', topScroll);
      }
      else {
        if ($('#toolbar-bar').length) {
          $pageSelector.css('top', topLoggedIn);
        }
        else {
          $pageSelector.css('top', top);
        }
      }
    });

  }
  function servicosLaboratoriais() {
    $('.servicos-laboratoriais .__buttons div').on('click', function () {
      $(this).closest('.__buttons').find('div').removeClass('active');
      $(this).addClass('active');
      $(this).closest('.servicos-laboratoriais').find('.__content:visible').fadeOut();
      $(this).closest('.servicos-laboratoriais').find('[rel=content-' + $(this).attr('rel') + '].__content').fadeIn();
    });
  }
  function listWithHiddenContent() {
    $('.__list-with-hidden-content .__list-with-hidden-content-title').click(function () {
      var mostra = 1;
      if ($(this).closest('li').hasClass('__list-with-hidden-content--active')) {
        mostra = 0;
      }
      $('li', $(this).closest('.__list-with-hidden-content')).removeClass('__list-with-hidden-content--active');
      if (mostra)
        $(this).closest('li').addClass('__list-with-hidden-content--active');
    });
  }
  function share() {
    if ($("#share-plugin").length) {
      const mobile = /mobi/i.test(navigator.userAgent);
      const shareData = {
        url: location.href,
        text: document.title,
      };
      if (mobile && navigator.canShare && navigator.canShare(shareData)) {
        $('#share-plugin > a').on('click', function () {
          navigator.share(shareData);
        });
        return;
      }
      if (typeof jsSocials === 'undefined') {
        console.log("timeout plz");
        setTimeout(share, 100);
        return;
      }
      $('#share-plugin').append("<div id='shared-networks'></div>");
      $('#share-plugin > a').off('click touch');
      $('#share-plugin > a').on('click touch', function () {
        $(this).closest("#share-plugin").toggleClass('active');
        return false;
      });

      // Botão de copiar link customizado
      jsSocials.shares.copy = {
        label: "Copy Link",
        logo: "fa fa-copy",
        shareUrl: "javascript:(function() { navigator.clipboard.writeText('{url}'); })()",
        countUrl: "",
        shareIn: "self",
      }

      jsSocials.shares.whatsapp = {
          label: "WhatsApp",
          logo: "fa fa-whatsapp",
          shareUrl: "https://wa.me/?text={url} {text}",
          countUrl: ""
      };
      var shareOptions = ["facebook", "twitter", "whatsapp", "copy"];

      $('#shared-networks').jsSocials({
        shares: shareOptions
      });
    }
  }

  function inputmask() {
    $("input[type=tel]").each((idx, el) => {
      Inputmask({ mask: "(99) 9999[9]-9999" }).mask([el]);
    });
  }
})(jQuery);
document.addEventListener('DOMContentLoaded',()=>{
  if (document.querySelector('#breadcrumb')) {
    if(document.querySelector('#breadcrumb').innerHTML.includes('Comercial')) {
      const styleElement = document.createElement('style');
      styleElement.innerHTML = "#breadcrumb .breadcrumb__item .mi { color: black !important; }";
      document.head.appendChild(styleElement);
    }
  }
  let quickAcessItems = document.querySelectorAll('.quick-access__item > a');
  quickAcessItems.forEach((qai)=>{
    setTimeout(()=>{ qai.setAttribute('target','_blank');},100)
  })
})
